import Vue from 'vue';
import Vuex from 'vuex';
import news from '@/store/news';
import archive from '@/store/archive';
import contractor from '@/store/contractor';
import achievements from '@/store/achievements';
import documents from '@/store/documents';
import directorship from '@/store/directorship';
import investor from '@/store/investor';
import customer from '@/store/customer';
import projects from '@/store/projects';
import estate from '@/store/estate';
import career from '@/store/career';
import tenders from '@/store/tenders';
import contacts from '@/store/contacts';
import request from '@/store/request';
import main from '@/store/main';
import jsha from './jsha';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    news,
    archive,
    contractor,
    achievements,
    documents,
    directorship,
    investor,
    customer,
    projects,
    estate,
    career,
    tenders,
    contacts,
    request,
    main,
    jsha,
  },
});
